function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77419 0H11.1929L15.9761 4.78409V13.971C15.9761 15.0865 15.0635 16 13.947 16H5.77422C4.65866 16 3.74609 15.0865 3.74609 13.971V2.02903C3.74609 0.913469 4.65866 0 5.77419 0Z",
    fill: "#E5252A",
    style: {
      fill: "#E5252A",
      fill: "color(display-p3 0.8980 0.1451 0.1647)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1953 0L15.9785 4.78409H11.711C11.4267 4.78409 11.1953 4.55184 11.1953 4.26747V0Z",
    fill: "#B71D21",
    style: {
      fill: "#B71D21",
      fill: "color(display-p3 0.7176 0.1137 0.1294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48047 6.8125H12.4998C12.7448 6.8125 12.9451 7.01275 12.9451 7.25781V11.3003C12.9451 11.5454 12.7448 11.7456 12.4998 11.7456H1.48047C1.23541 11.7456 1.03516 11.5454 1.03516 11.3003V7.25781C1.03516 7.01275 1.23544 6.8125 1.48047 6.8125Z",
    fill: "#B71D21",
    style: {
      fill: "#B71D21",
      fill: "color(display-p3 0.7176 0.1137 0.1294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18325 7.63745H3.35206C3.20941 7.63745 3.09375 7.75311 3.09375 7.89576V9.2582V9.59376V10.6627C3.09375 10.8054 3.20941 10.921 3.35206 10.921C3.49472 10.921 3.61038 10.8054 3.61038 10.6627V9.85208H4.18322C4.78397 9.85208 5.27272 9.36333 5.27272 8.76261V8.72695C5.27275 8.1262 4.784 7.63745 4.18325 7.63745ZM4.75613 8.76258C4.75613 9.07845 4.49913 9.33542 4.18325 9.33542H3.61038V9.25817V8.15404H4.18322C4.49909 8.15404 4.75609 8.41104 4.75609 8.72689V8.76258H4.75613ZM6.963 7.63745H6.13184C5.98919 7.63745 5.87353 7.75311 5.87353 7.89576V10.6627C5.87353 10.8054 5.98919 10.921 6.13184 10.921H6.963C7.56375 10.921 8.0525 10.4323 8.0525 9.83154V8.72695C8.0525 8.1262 7.56375 7.63745 6.963 7.63745ZM7.53588 9.83151C7.53588 10.1474 7.27887 10.4044 6.963 10.4044H6.39016V8.15404H6.963C7.27887 8.15404 7.53588 8.41104 7.53588 8.72689V9.83151ZM9.22016 8.15408V8.86914H10.4176C10.5602 8.86914 10.6759 8.9848 10.6759 9.12745C10.6759 9.27011 10.5602 9.38576 10.4176 9.38576H9.22016V10.6627C9.22016 10.8054 9.1045 10.921 8.96184 10.921C8.81919 10.921 8.70353 10.8054 8.70353 10.6627V7.89576C8.70353 7.75311 8.81919 7.63745 8.96184 7.63745H10.6242C10.7668 7.63745 10.8825 7.75311 10.8825 7.89576C10.8825 8.03842 10.7668 8.15408 10.6242 8.15408H9.22016Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.623d1fe94dff48f5c4b2299422931ce2.svg";
export { ForwardRef as ReactComponent };